import React from "react";
import "./SpinnerOverlay.css";

export const SpinnerOverlay = () => {
  return (
    <div className="spinner-overlay">
      <div className="spinner" />
    </div>
  );
};
